import clsx from 'clsx';
import { ReactNode } from 'react';

export default function PageContainer({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}) {
  return <div className={clsx('flex flex-col flex-1 pb-[32px] w-full', className)}>{children}</div>;
}
